export default "__VITE_ASSET__$sEZUvrq__"